
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import ExpertiseSelector from "../../../common/expertise/selector/ExpertiseSelector";

export default function FieldExpertise({ onChange, workshop, isDesktop }) {
	const [expertises, setExpertises] = useState([]);
	const [activeExpertiseIds, setActiveExpertiseIds] = useState([]);
	const [errorMessage, setErrorMessage] = useState('');
	const workshopId = workshop?.id;

	useEffect(() => {
		fetchExpertises();
	}, []);

	function fetchExpertises() {
		api.listWorkshopExpertises({
			workshop_id: workshopId,
		}).then((result) => {
			if (result['all_expertises'] && result['active_expertises']) {
				let activeExpertiseIds = result['active_expertises'].map((expertise) => expertise.id);
				setActiveExpertiseIds(activeExpertiseIds);
				setExpertises(result['all_expertises']);
				onChange(activeExpertiseIds);
			}
		}).catch((err) => {
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	return (
		<div>
			<div className="font-Vazir-700 text-[16px] text-midGray text-center">تخصص‌ها</div>
			<div className="spacer p-[5px]"></div>
			{expertises && (
				<ExpertiseSelector
					expertises={expertises}
					initActiveExpertiseIds={activeExpertiseIds}
					onChange={onChange}
					isDesktop={isDesktop}
				/>
			)}
			{
				errorMessage && (
					<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
				)
			}
		</div >
	)
}
